import { render, staticRenderFns } from "./ContestSwornEditComponent.vue?vue&type=template&id=c0a5104a&scoped=true"
import script from "./ContestSwornEditComponent.vue?vue&type=script&lang=js"
export * from "./ContestSwornEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestSwornEditComponent.vue?vue&type=style&index=0&id=c0a5104a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a5104a",
  null
  
)

export default component.exports